module.exports = __webpack_public_path__ + "static/media/lefticon.d950c219.svg";